<template>
  <div>
    <div class="card-header">
      <div class="card-header-title">
        <div class="card-header-title-text" v-if="hasShowTable">
          Sua tabela de coparticipação
        </div>
        <div>{{ titulo }}</div>
      </div>

      <div class="card-header-text" v-if="hasShowTable">
        <div>
          <span> {{ texto1 }}</span>
        </div>
        <div class="card-header-text-2">
          <span>{{ texto2 }}</span>
        </div>
      </div>

      <div
        class="card-header-text-no-content"
        v-if="!hasShowTable && !hasShowError && !isLoading"
      >
        <div>
          <strong> Seu plano não possui coparticipação </strong>
        </div>
        <div class="card-header-text-2-no-content">
          <span
            >Seu plano cobre integralmente os procedimentos, por isso não há uma
            tabela de coparticipação para exibir.</span
          >
        </div>
      </div>

      <div class="card-header-text-error" v-if="hasShowError">
        <div class="info-circle">
          <img class="info-error" src="../../assets/images/info.svg" />
        </div>
        <div>
          <strong>Não foi possível carregar as informações</strong>
        </div>
        <div class="card-header-text-2-error">
          <span
            >Por favor, atualize a página ou tente novamente mais tarde.</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    titulo: String,
    texto1: String,
    texto2: String,
    texto3: String,
    hasShowTable: Boolean,
    hasShowError: Boolean,
    isLoading: Boolean,
  },
};
</script>

<style scoped>
.card-header-title-text {
  color: var(--color-brand-primary);
  font-family: Roboto-Slab;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 19.2px;
  margin-bottom: 10px;
}
.info-circle img {
  width: 24px;
}
.card-header-text-error strong {
  font-family: UnimedSlab-SemiBold;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 42px;
}
.card-header-text-2-error {
  font-family: UnimedSans-Regular;
  font-size: 14px;
}
.card-header {
  width: 100%;
  display: block;
  text-align: center;
  background-color: #f3f3f3;
}

.card-header-title {
  color: var(--color-brand-primary);
  font-size: 35px;
  font-family: UnimedSlab-SemiBold;
  width: auto;
  margin: auto;
  padding-top: 40px;
  padding-bottom: 10px;
}

.card-header-text {
  font-size: 14px;
  font-family: UnimedSans-SemiBold;
  padding-top: 10px;
}

.card-header-text span {
  font-weight: 500;
}

.card-header-text-2 {
  font-family: UnimedSans-Regular;
}

@media (min-width: 320px) {
  .card-header {
    height: 280px;
  }
}
@media (min-width: 480px) {
  .card-header {
    height: 220px;
  }
}
</style>
